import { useEffect, useState } from "react";

// Returns `value` after it has stopped changing for `delay` ms. Used to keep
// keystroke-by-keystroke search boxes from firing a request per character.
export default function useDebouncedValue(value, delay = 300) {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debounced;
}
